/**
 * Guest is a checkout contact. Renter is the contact minted for an orgless sign-in.
 */
export enum ProtoContactTypeEnum {
  GUEST = 'guest',
  RENTER = 'renter',
}
